<template>
  <div class="daily-bonus-bg" :class="{ iframe_cover: gameUrlFromStore }">
    <div class="daily-bonus-frame">
      <header class="header-frame">
        <img class="hero-img-pc" :src="require(`@/assets/${$store.getters.currentTheme}/images/db_hero_img_pc.png`)" alt="">
        <img class="hero-img-mb" :src="require(`@/assets/${$store.getters.currentTheme}/images/db_hero_img_mb.png`)" alt="">
        <button v-if="$store.getters.token" type="button" class="btn btn-db-register" @click="goHome">
          戻る
        </button>
        <button v-else type="button" class="btn btn-db-register" @click="goHomeLogin">
          ログイン
        </button>
        <div class="hd-tag-pc">
          <h5 class="title">
            ボーナスの受け取り方
          </h5>
          <ul class="notice-list">
            <li>Katsu現金ウォレットのベットの累積ゲームベット額が計算されます。</li>
            <li>毎日指定のゲームにベットすると、タスクボーナスが自動で配付されます。</li>
            <li>タスクボーナスは「Katsuボーナスウォレット」に配付されます。</li>
            <li>
              ベット額が規定の20倍に達すると、「Katsuボーナスウォレット」から自動で
              「Katsu現金ウォレット」に移動されます。
            </li>
          </ul>
        </div>
        <div class="hd-tag-mb">
          勝win へようこそ！
        </div>
      </header>
      <div class="daily-bonus-container grid cards">
        <div
          v-for="(event, index) in detail"
          :key="event.id"
          class="daily-card"
          :class="{'current': weekday === index+1,
                   'unopened': $store.getters.token && reward.reward_status[index].event_member_id === -1 && weekday !== index+1,
                   'completed': $store.getters.token && reward.reward_status[index].amount !== 0 && hasCompleted}"
        >
          <div class="db-days">
            タスク <span class="db-number">{{ event.weekday }}</span>
          </div>
          <div class="db-games-img-frame unopened">
            <img class="db-games-img" :src="event.game.image" :alt="'Day ' + event.weekday + ' Image'">
            <div class="db-needs-coin">
              <img class="icon-db-coin" :src="require(`@/assets/${$store.getters.currentTheme}/images/db_icon_coin.png`)" alt=""><span>{{ event.prize | numberFormat }}</span>
            </div>
          </div>
          <p class="db-needs-text">
            必要なベット額 <span class="amount" />{{ event.performance | numberFormat }}
          </p>
          <button v-if="$store.getters.token" class="btn db-btn-play">
            <template v-if="reward.reward_status[index].event_member_id !== -1 && reward.reward_status[index].amount === 0">
              <span class="db-btn-text" @click="getEvent(reward.reward_status[index])">GET</span>
            </template>
            <template v-else>
              <span class="db-btn-text" @click="checkQualification(event)">今すぐ遊ぶ</span>
            </template>
            <img
              class="icon-db-lock"
              :src="require(`@/assets/${$store.getters.currentTheme}/images/db_icon_lock.png`)"
            >
          </button>
          <div class="completed-card">
            <div class="completed-box">
              <div class="completed-circle">
                <img
                  class="db-icon check"
                  :src="require(`@/assets/${$store.getters.currentTheme}/images/icon_check_white.png`)"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div class="db-gift-pic-right mb-gift-inside">
          <img
            :src="require(`@/assets/${$store.getters.currentTheme}/images/db_gift_right.png`)"
            alt=""
          >
        </div>
      </div>
      <div class="db-content">
        <div class="notice-content-mb">
          <h5 class="title">
            ボーナスの受け取り方
          </h5>
          <ul class="notice-list">
            <li>Katsu現金ウォレットのベットの累積ゲームベット額が計算されます。</li>
            <li>毎日指定のゲームにベットすると、タスクボーナスが自動で配付されます。</li>
            <li>タスクボーナスは「Katsuボーナスウォレット」に配付されます。</li>
            <li>
              ベット額が規定の20倍に達すると、「Katsuボーナスウォレット」から自動で
              「Katsu現金ウォレット」に移動されます。
            </li>
          </ul>
        </div>
        <button v-if="$store.getters.token" class="btn db-btn-login mb-login-margin" @click="goHome">
          戻る
        </button>
        <button v-else class="btn db-btn-login mb-login-margin" @click="goHomeLogin">
          ログイン
        </button>
      </div>

      <div class="db-gift-pic-left">
        <img
          :src="require(`@/assets/${$store.getters.currentTheme}/images/db_gift_left.png`)"
          alt=""
        >
      </div>
      <div class="db-gift-pic-right">
        <img
          :src="require(`@/assets/${$store.getters.currentTheme}/images/db_gift_right.png`)"
          alt=""
        >
      </div>
    </div>
    <footer class="ft-frame">
      <p class="ft-content">
        Copyright © Katsuwin 2022. All Rights Reserved.
      </p>
    </footer>
    <!-- iframe Game -->
    <div v-show="gameUrlFromStore" class="iframe-background">
      <div v-show="gameUrlFromStore" class="overlay_bg bg-repeat bg-green">
        <button class="game_btn" @click="clearGameUrl">
          EXIT
        </button>
      </div>
      <iframe v-show="gameUrlFromStore" ref="gameIframe" :src="gameUrlFromStore" class="iframe-content" />
    </div>
  </div>
</template>

<script>
import { getEvent, getEventDetail, joinEventV2, receiveV2, getEventQualification } from '@/api/event'
import { gameStart } from '@/utils/games'
import { showNotice } from '@/utils/tool'

export default {
  name: 'DailyAttend',
  data() {
    return {
      event_id: 0,
      detail: [],
      reward: [],
      weekday: 0,
      hasCompleted: false,
      isJoin: false
    }
  },
  computed: {
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    }
  },
  watch: {
    gameUrlFromStore(newVal) {
      const headerElement = document.querySelector('header')
      if (newVal) { // If the iframe is shown
        headerElement.style.display = 'none'
        this.disableScrolling()
      } else { // If the iframe is hidden
        this.enableScrolling()
        headerElement.style.display = 'block'
      }
    }
  },
  created() {
    getEvent().then(response => {
      response.data.data.list.forEach(item => {
        if (item.type === 'daily_attend') {
          this.event_id = item.id
          if (this.$store.getters.token) {
            this.getEvent(item)
          }
        }
      })

      getEventDetail(this.event_id).then(response => {
        this.detail = response.data.data.setting
        this.reward = response.data.data.reward
        this.showDay()
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearGameUrl)
  },
  mounted() {
    window.addEventListener('beforeunload', this.clearGameUrl)
  },
  methods: {
    goHome() {
      this.$router.push('/')
      setTimeout(() => {
        window.location.reload()
      }, 300)
    },
    goHomeLogin() {
      localStorage.setItem('redirectAfterLogin', true)
      this.goHome()
    },
    playGame(event) {
      if (!this.reward.member_can_join_next_prize || this.isJoin) {
        this.$store.commit('SET_DAILY', true)
        gameStart('game', event.game)
        return
      }
      joinEventV2({ event_id: this.event_id }).then(response => {
        if (response.status === 200) {
          this.$store.commit('SET_DAILY', true)
          gameStart('game', event.game)
          this.isJoin = true
        }
      }).catch((e) => {
        showNotice(e.response.data.msg)
      })
    },
    disableScrolling() {
    // Disable scrolling
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
    // Enable scrolling
      document.body.style.overflow = ''
    },
    clearGameUrl() {
      this.$store.commit('SET_GAME_URL', null)
      this.$store.state.app.tempGameUrl = ''
    },
    showDay() {
      this.reward.reward_status.forEach(item => {
        // 未報名
        if (item.event_member_id === -1) {
          // 當天 顯示play
          if (item.weekday === this.reward.processing_day_index) {
            this.weekday = item.weekday
          }
        }
      })
    },
    getEvent(event) {
      receiveV2(event.event_member_id).then(response => {
        if (response.data.data.code === 0) {
          this.hasCompleted = true
        }
      })
    },
    checkQualification(event) {
      getEventQualification('daily_attend').then(response => {
        const code = response.data.data.code
        if (code === 1001) {
          showNotice(this.$t('Bao.special_deposit_err6'), '', true, '', this.$t('Bao.confirm_btn'))
        } else if (code === 2001 || code === 3001) {
          const message = this.$t('Bao.unavailible_3') + code + this.$t('Bao.unavailable_2')
          showNotice(message, '', true, '', this.$t('Bao.confirm_btn'))
        } else if (code === 2101) {
          showNotice(this.$t('Bao.member_type_not_pass'), '', true, '', this.$t('Bao.confirm_btn'))
        } else {
          this.playGame(event)
        }
      }).catch((error) => {
        showNotice(error.response.data.msg, '', true, '', this.$t('Bao.confirm_btn'))
      })
    }
  }
}
</script>

